import React from "react";
import styles from "../Loan/Loan.scss";
import { InfoPopover } from "~views/shared/InfoPopover/InfoPopover";

interface ILoanCalculationCellProps {
  value: string;
  label: string;
  helpHeader?: string;
  helpText?: string;
}

export const LoanCalculationCell = ({
  value: lineOne,
  label: lineTwo,
  helpText,
  helpHeader,
}: ILoanCalculationCellProps) => {
  return (
    <td className={styles.loanCalculationCellContainer}>
      <div className={styles.loanCalculationCell}>
        <div className={styles.lineOne}>{lineOne}</div>
        <div className={styles.lineTwo}>
          {lineTwo}
          {(helpText || helpHeader) && (
            <InfoPopover content={helpText} popoverTitle={helpHeader} color="black" className={styles.questionMark} />
          )}
        </div>
      </div>
    </td>
  );
};
